export const TRANSLATIONS_EN = {
  hello: 'Hello',
  welcome: 'Bienvenid@',
  test: 'Prueba',
  nav: {
    home: 'Home',
    myClass: 'My Class',
    resources: 'Resources',
    webinars: 'Webinars',
    bupmode: 'BUP Mode!',
    inbox: 'Inbox',
    sendMessage: 'Send BUP MODE!',
    archivedCases: 'Closed messages',
    data: 'Data!',
    profileCard: {
      myAccount: 'MY ACCOUNT',
      logOut: 'LOG OUT',
    },
    footer: {
      text1: '2021 BRAVEUP',
      text2: '2021 BRAVEUP. All rights reserved',
    },
    error: {
      errorMesssage: 'Opp, please reload the page in the following button',
      buttonError: 'Try Again',
    },
  },
  pages: {
    profile: {
      title: 'My Account',
      name: 'Name',
      email: 'Email',
      school: 'School name',
      role: 'Role',
      course: 'Level',
      buttonTextPassword: 'Change Password',
      changePasswordMessage: 'Message Sent!',
      messageDescription1: 'An Email has been sent to ',
      messageDescription2: 'with the instructions to change your password.',
    },
    login: {
      welcomeText1: 'Welcome to BRAVE UP!',
      welcomeText2: 'Please enter you email and password to login.',
      emailPlaceHolder: 'myemail@braveup.com',
      emailLabel: 'Email',
      emailRequiredMessage: 'Email required.',
      emailInvalidMessage: 'Invalid Email.',
      passwordLabel: 'Password',
      PasswordRequiredMessage: 'Password required.',
      signinButton: 'Log in',
      forgottenPassword: 'Forgot your password?',
    },
    home: {
      welcomeTitle: 'Hello',
      introText:
        'We are BRAVE UP! And this platform will be our meeting place throughout the year. Here you will find everything you need for the improvement of face-to-face and digital coexistence of your school community with the participation of everyone involved. Meanwhile, stir up your curiosity and go find all the available contents and functions.',
      imgAlt: 'Image Information',
      bupSection: 'BRAVE UP! MODE',
      lastMessages: 'Last messages received',
      resourceSection: 'LAST RESOURCES',
      dataSection: 'BRAVE UP! DATA',
      dataPanel: {
        button1Text: 'Get to know and set up your school’s resources',
        button2Text: 'Follow-up of surveys last results',
        buttonATPS: 'Get to know the school coexistence resources',
        buttonAnswer: 'Answer the school coexistence diagnosis',
        resourceButton:
          'Get to know and download load the student support material',
      },
      errorMessage:
        '   An error occurred while downloading the resources, please try again.',
      noResources: 'there are no available resources',
      noMessage: 'No messages in your inbox',
    },
    resources: {
      pageName: 'Resources',
      pageNameText1: 'Resource:',
      pageNameText2: 'No name',
      title: 'Select the area where you want to work:',
      textNoResources: 'There are no resources',
      textNoLevels: 'There are no levels',
    },

    // home: {
    //   welcomeTitle: 'Hello',
    //   introText:
    //     'The first online software for managing school relations. In just a few steps you can prevent, predict and detect risk situations such as bullying and cyberbullying.',
    //   imgAlt: 'Image Information',
    //   bupSection: 'BRAVE UP! MODE',
    //   resourceSection: 'LAST RESOURCES',
    //   dataSection: 'BRAVE UP! DATA',
    //   dataPanel: {
    //     button1Text: 'Data instruments available for your community.',
    //     button2Text: 'Follow up and check the results of our instruments',
    //     buttonATPS: 'Review the data instruments available for your community.',
    //     buttonAnswer: 'Take the survey',
    //     resourceButton: 'Resources for support the process',
    //   },
    //   errorMessage: 'Oops, please try again',
    //   noResources: 'No resources available',
    // },
    // resources: {
    //   pageName: 'Resources',
    //   pageNameText1: 'Resource:',
    //   pageNameText2: 'No Name',
    //   title: 'Discover the resources in the following categories:',
    //   textNoResources: 'No resources',
    //   textNoLevels: 'No level',
    // },
    webinars: {
      pageName: 'Webinar',
      pageName2: 'There is no seminar',
      introText1:
        'In order to know more and learn about school coexistence, the digital world of your students and how to escort them, we invite you to take part in our web talks. You can participate live and interact, leaving your questions and comments in the chat (you can only comment if you are registered in Youtube or with your Gmail username). Remember that the chat will be available in the platform for 2 weeks; you will therefore be able to see them again if you want to review and go deeper into its contents.',
      introText2:
        'In order to know more and learn about school coexistence, the digital world of your children and how to escort them, we invite you to take part in our web talks. You can participate live and interact, leaving your questions and comments in the chat (you can only comment if you are registered in Youtube or with your Gmail username). If you were unable to connect when the web talks were held, remember that they will be available in the platform for 2 weeks.',
      noWebinarsText:
        ' No talks have taken place in your school yet, the dates will be announced by the person in charge of coexistence in your community. After the live broadcast of the chat, it will be kept available in this space.',
      titleSatisfactionSurvey: 'Satisfaction Survey',
      answerHereText: 'Answer here',
      titleDownloadableDoc: 'Downloadable document',
      downloadText: 'Download here',
    },

    modeBup: {
      pageName: 'BUP! Mode',
      notificationHelper: {
        titleHelper: 'Guide for good use',
        bodyHelper: 'What is the BRAVE UP! MODE?',
        bodyHelper2: 'Frequent questions',
      },
      send: {
        sendMessageTextComponent: {
          titleEce: 'What is the BRAVE UP! MODE?',
          text1Ece:
            'It is a direct communication channel with the school coexistence team, where either anonymously or not, teachers, students and/or parents can write about different coexistence situations that take place between the members of the school community, both on the physical or digital environment. This will contribute to strengthen a community where everyone is responsible of building a healthy school coexistence.',
          text2Ece: 'Here you will find the',
          text3EceSpan: 'Inbox',
          text4Ece:
            'where you will receive the messages sent by your community and the section',
          text5EceSpan: 'Archived cases',
          text6Ece:
            'where you can save the cases that have already been solved. We invite you to check both sections:',
          textButton1Ece: 'Inbox',
          textButton2Ece: 'Archived cases',
          text7EceSpan:
            'Remember that you can get to know and deal with the problems and needs of your community in real time.',
          text8Ece:
            'Getting to know challenging experiences and situations they are facing enables to act preventively, as well as giving support and containment.',
          textParent:
            'Here you will be able to express and communicate situations such as conflicts, aggressions or misunderstandings between members of the community, as well as finding support in the problems that your children might be going through.',
          text1Teacher:
            'Here you can communicate individual or group school coexistence situations.',
          text2Teacher:
            'So that the coexistence team can count upon information and background, as well as informing about the needs and communicating the concerns in relation to the students’ wellbeing. Finding support to effectively intervene with the students.',
          text1Student:
            'Here is where you can find solace, containment and support in order face the situation that has been exposed in a positive manner.',
          text2Student:
            'You can communicate situations and/or experiences, either personal or someone else’s, concerning school bullying, cyber bullying or other situations that affect you and you don’t know how to tackle. You can also use this space to put forward proposals for the improvement of coexistence within your community.',
        },
        sendMessageformComponent: {
          notificationMessage: 'Message sent!',
          notificationDescription:
            'Hello. We hope you’re doing well and that the situation you have described can be solved in a positive manner. The person in charge of coexistence has already received your message and will be answering you in less than 24 hours. Thank you so much for using this space and trusting the BUP Mode.',
          notificationErrorMessage:
            'An unexpected error has occurred. Please try again.',
          formTitle: 'Your voice is important!',
          formText: 'Make yourself heard. We’re here to listen to you',
          formTextMessage: 'You must place a message.',
          formPlaceholder: 'Ex: I have a problem with...',
          formCheckBoxText: 'Send anonymously',
          formButton: 'Send',
        },
        collapseTitle: 'WHAT IS THE BUP! MODE?',
        collapseText:
          'It is a direct communication channel with the school coexistence team, where either anonymously or not, teachers, students and/or parents can write about different coexistence situations that take place between the members of the school community, both on the physical or digital environment. This will contribute to strengthen a community where everyone is responsible of building a healthy school coexistence. The messages sent through this space are confidential, only the school coexistence team can see them and will answer you shortly.',
      },
      inbox: {
        breadcrumbText1: 'BUP! MODE',
        breadcrumbText2: 'INBOX',
        title: 'MESSAGE LIST',
        MessagesListComponent: {
          errorText:
            'An error occurred while loading the messages, please try again.',
          noMessageText: 'You have no messages',
        },
        MessageElementComponent: {
          tag1: 'OPEN',
          tag2: 'CLOSED',
          button1Text1: 'Archive case',
          button1Text2: 'Open case',
          button2Text1: 'Open',
          button2Text2: 'Check',
          closeMessage: 'Are you sure you want to archive this case?',
          openMessage: 'Are you sure you want to open this case?',
          okText: 'Yes',
          cancelText: 'No',
          isOpenMessageClosed: 'Archive case',
          isOpenMessageOpen: 'Open case',
          isOpenMessageOpen2: 'Open',
          isOpenMessageReview: 'Review',
        },
      },
      archivedCases: {
        breadcrumbText1: 'BUP! MODE',
        breadcrumbText2: ' ARCHIVED CASES',
        title: 'archived cases',
        breadcrumbText3: 'MESSAGE',
      },
      direct: {
        tooltip: 'Return',
        breadcrumbText1: 'INBOX',
        breadcrumbText2: 'ARCHIVED CASES',
        breadcrumbText3: 'INBOX',
        breadcrumbText4: 'MESSAGE',
      },
      chatbox: {
        buttonText: 'Open case',
        buttonText1: 'Send',
        buttonText2: 'Refresh',
        chatPlaceHolder: 'Send a message',
        messageRequired: 'Message required',
        anonymousCheckBoxState1: 'Continue anonymous',
        anonymousCheckBoxState2: 'Send anonymous',
      },
      messageState: {
        text1: 'Inbox',
        text2: 'Archived cases',
        messageSuccess: 'The message was successfully moved to',
        errorMessage: 'An error occurred, try again',
      },
    },

    data: {
      components: {
        buttonBackText: 'BACK',
        inputFormMessage: 'Required field',
      },
      title: 'BRAVE UP! DATA',
      linkTextHere: 'here.',
      welcomeTextECE:
        'Welcome to BRAVE UP! DATA. We are the ones in charge of gathering the data within the school, analyze it and deliver recommendations that enable you to focus your work and plan the interventions concerning physical and digital school coexistence in the best possible way. In this section you will find a series of tools that will help you getting to know the instruments and implementing them in your school, answer the diagnosis, carry out the follow up, check the results and recommendations we will prepare for you.',
      title1ECE: 'Get to know the instruments',
      description1ECE:
        'Check all the information you need in order to start collecting your school data.',
      title2ECE: 'Activate and deactivate the instruments',
      description2ECE:
        'You must request the activation of each instrument you want to start applying, and make sure to close it when the process has ended. You will also find the dissemination charts and the "Orientation Guide for Collecting Data in Class"',
      title3ECE: 'Answer the diagnosis',
      description3ECE:
        'It’s important that you also take part answering once the diagnosis is available',
      title4ECE: 'Do a follow-up and check the results',
      description4ECE:
        'We will deliver a progress status while you are collecting the data so you can keep track of them. When you close the process, we will deliver a report with results and recommendations for your school',
      welcomeTextStudent:
        'Welcome to BRAVE UP DATA! We are the ones in charge of gathering the data within the school, analyze it and deliver recommendations in order to improve physical and digital school coexistence. In this section you can get to know the instruments we shall apply and take part once they’re available.',
      title1Student: 'Get to know the instruments',
      description1Student:
        'Get to know the instruments that will be applied in school',
      title2Student: 'Answer',
      description2Student:
        'Your opinion is very important in order to improve school coexistence. Be a part and answer',
      title3Student: 'Answer the Sociogram',
      description3Student:
        'We invite you to answer the sociogram and see how the relationships are inside your class.',
      welcomeTextTeacher:
        'Welcome to BRAVE UP DATA! We are the ones in charge of gathering the data within the school, analyze it and deliver recommendations in order to improve physical and digital school coexistence. In this section you can get to know the instruments, answer the diagnosis and find the necessary material to help collecting data from the students.',
      title1Teacher: 'Get to know the instruments',
      description1Teacher:
        'Get to know the instruments that can be applied in your school',
      title2Teacher: 'Answer the diagnosis',
      description2Teacher:
        'Your opinion is very important in order to improve school coexistence. Be a part and answer',
      title3Teacher: 'Support your students',
      desccription3Teacher:
        'Check the material we have prepared so that you can follow the implementation of the instrument and answer all the doubts that might arise, downloading the "Orientation Guide for Collecting Data in Class".',
      sociogramTeacherTitle: 'Active the sociogram',
      sociogramTeacherFinishTitle: 'Finish the sociogram',
      sociogramTeacherDescription:
        'The sociogram allows us to reflect in a graph the relationship between the students in each level. We invite you to activate it in your class.',
      sociogramMessageActivated:
        'The sociogram for your course was successfully activated . When all your students answer the instrument, you must close the process by clicking on the button "End sociogram"',
      sociogramMessageCompleted: 'Sociogram completed',
      sociogramMessageAlert: 'Sociogram successfully activated',
      textPopover: 'Download material here',
      instruments: {
        dividerText1: 'AVAILABLE INSTRUMENTS',
        dividerText2:
          'GET TO KNOW THE DETAILS OF THE SCHOOL COEXISTENCE DIAGNOSIS',
        dividerText3: 'GET TO KNOW THE DETAILS OF THE SOCIOGRAM',
        introText:
          'BRAVE UP! DATA offers different instruments so that your school can collect relevant information concerning school coexistence.',
        diagnosticTitle: 'School Well Beign diagnosis',
        sociogramTitle: 'Sociogram',
        whoAnswerTitle: 'Who can answer?',
        durationTitle: 'How long does the survey take?',
        whatINeedTitle: 'What do I need to get started?',
        resourcesTitle:
          'What resources does BUP! have to support this process?',
        whatMeasuresInstrumentTitle: 'What does this instrument measure?',
        whatMeasuresInstrumentLink: 'Download the following document.',
        whenItEndsTitle: 'When does the process end?',
        startActivationButton: 'Start activation',
        whoCanAnswerTitle: 'Who can answer?',
        howLongTitle: 'How long does the survey take?',
        whatMeasuresTitle: 'What does it measure?',
        diagnosticDescriptionECE:
          'The aim is to know the status of coexistence in the school and identify where there is room for improvement. It is oriented towards the entire school community.',
        sociogramDescriptionECE:
          'It seeks to know the relations within the classes in order to generate actions that strengthen links. It is oriented towards the students.',
        whoAnswerDescriptionECE:
          'Students from 4th to 12th grade. Parents, teachers and educational assistants of all levels.',
        durationDescriptionECE: 'Approximately 25-30 minutes.',
        whatINeedDescriptionECE:
          'To know the number of people in each role, coordinating the work with the rest of the colleagues and request the activation.',
        resourcesDescription1ECE:
          'Dissemination charts in order to promote the diagnosis with your community.',
        resourcesDescription2ECE:
          '"Orientation Guide for Collecting Data in Class"',
        whatMeasuresInstrumentDescriptionECE:
          'Psychosocial wellbeing, appreciation of relationships, management of coexistence, violence and aggressions in school, among others. For further detail,',
        whenItEndsDescriptionECE:
          'You have to request the closing of the Diagnosis and BRAVE UP! DATA will start to prepare the Results Report which will be available in this same platform.',
        whoCanAnswerDescriptionECE: 'Students from 4th to 12th grade.',
        durationSociogramDescriptionECE: 'Approximately 25-30 minutes.',
        whatMeasuresDescriptionECE:
          'The relationships of sympathy and tension that each student senses in his class.',
        diagnosticDescriptionTeacher:
          'It seeks to know the state of school coexistence and identify where there is room for improvement. It is oriented towards the entire school community.',
        sociogramDescriptionTeacher:
          'It seeks to know the relations within the classes in order to generate actions that strengthen links. It is oriented towards the students.',
        whoAnswerDescriptionTeacher:
          'Students from 4th to 12th grade. Parents, teachers and educational assistants of all levels.',
        durationDescriptionTeacher: 'Approximately 25-30 minutes.',
        resourcesDescription1Teacher:
          'Dissemination charts in order to promote the diagnosis with your community.',
        resourcesDescription2Teacher:
          '"Orientation Guide for Collecting Data in Class "',
        whatMeasuresInstrumentDescriptionTeacher:
          'Psychosocial wellbeing, appreciation of relationships, management of coexistence, violence and aggressions in school, among others. For further detail,',
        whenItEndsDescriptionTeacher:
          'Once the entire community has answered, we will deliver a Results and Recommendations Report to the Coexistence Team.',
        whoCanAnswerDescriptionTeacher: 'Students from 4th to 12th grade.',
        durationSociogramDescriptionTeacher: 'Approximately 25-30 minutes.',
        whatMeasuresTeacher:
          'The relationships of sympathy and tension that each student senses in his class ',
        activeSociogramTitle: 'ACTIVATE SOCIOGRAM',
        activeSociogramDescription:
          'We invite you to select the students that will answer the sociogram. The students that you do not select, they will not be part of the sociogram.',
        activateStudentTableheader1: 'Student Name',
        activateStudentTableheader2: 'Email',
        totalStudents: 'Total number of students',
        studentSelected: 'You have selected:',
        studentTag: 'students',
        successMessage1: 'Successful Sociogram Activation',
        button1: 'Back to Data',
        errorMessage: 'Oops, please try again',
        sentButton: 'Send Activation',
        cancelbutton: 'Cancel',
        confirmMessage: 'Confirm Activation',
        modalTitle: 'You are about to activate the sociogram for your class',
        questionMessage: 'Are you sure you want to continue?',

        diagnosticDescriptionStudent:
          'It is oriented towards the entire school community. It seeks to know the state of school coexistence and identify its fortitudes and weakness in order to improve where needed.',
        sociogramDescriptionStudent:
          'It is oriented towards the students. It seeks to know the relationships that develop between classmates and generate actions that help strengthening those links',
        whoAnswerDescriptionStudent:
          'Students from 4th to 12th grade. Parents, teachers and educational assistants of all levels.',
        durationDescriptionStudent: 'Approximately 25-30 minutes.',
        whatMeasuresInstrumentDescriptionStudent:
          'Wellbeing within the school, relationships between members of the community, spaces of participation, situations of violence and aggression among others.',
        whenItEndsDescriptionStudent:
          'Once the entire community has answered, we will deliver a Results and Recommendations Report to the Coexistence Team.',
        whoCanANswerDescriptionStudent: 'Students from 4th to 12th grade.',
        durationSociogramDescriptionStudent: 'Approximately 25-30 minutes.',
        whatMeasuresDescriptionStudent:
          'The relationships of sympathy and tension that each student senses in his class',
      },
      activationSteps: {
        popoverText1: 'Download guide here',
        popoverText2: 'Download charts here',
        dividerTitle: 'STEPS FOR THE ACTIVATION',
        welcomeText:
          'Before requesting activation make sure you have followed all the steps we recommend below in order to get the best data collection possible.',
        step1Title:
          'Find out the exact number of people that are part of every sector',
        step1Description:
          'This will allow us to know how many answers we need in order to get the school’s representative data of students from 4th to 12th grade, teachers, educational assistants and parents. We will request this information when we activate the survey.',
        step2Title: 'Prepare the dates when the data will be collected',
        step2Description:
          'Before requesting the activation, it’s important that you schedule the data collection in your school so that you can achieve a wide participation and that the entire process does not take longer than the estimated 2 weeks.',
        step3Title: 'Coordinate the data collection with the room teachers',
        step3Description:
          "Our recommendation is that students answer the diagnosis in one class period and with the support of their room teacher in case of any doubts that might arise. Remember you can download the 'Orientation Guide for Collecting Data in Class'.",
        step4Title: 'Disseminate within the community',
        step4Description:
          'We’ve designed a set of charts so that you can communicate and motivate the participation of the community. They are ready for download!',
        step5Title: 'Activate the instrument!',
        step5Description:
          'Once the previous steps have been completed, you will be ready to request the activation of the instrument. This will occur within 72 hours and will be available in this platform during a maximum of 3 weeks. Our recommendation is that you only activate it when your school is ready for its implementation.',
        step6Title: 'Get the results report',
        step6Description:
          'When you have reached 2 weeks implementation and the minimum number of answers, you must request the closing of the instrument so that we can start analyzing the results. Otherwise it will deactivate at the end of the 3rd week. The report will be available in this platform in no longer than 3 weeks.',
        activationButtonText1: 'All ready?',
        activationButtonText2: 'Start activation',
      },
      startActivation: {
        dividerTitle: 'START ACTIVATION',
        title: 'DIAGNOSIS OF SCHOOL WELL BEING',
        introText:
          'The first thing you must do to activate the instrument is to fill in the number of people that form each one of the sectors that will participate. This is how you will know the minimum number of answers you need so that the data truly reflects your community’s reality.',
        studentsTitle: 'Students',
        studentsDescription:
          'Write down the total number of students from 4th to 12th grade.',
        parentsTitle: 'Parents',
        parentsDescription:
          'Write down the total number of families there are in school',
        teachersTitle: 'Teachers',
        teachersDescription:
          'Write down the total number of teachers there are in school',
        assistantsTitle: 'Educational assistants',
        assistantsDescription:
          'Write down the total number of professionals that work directly with the students, including the Coexistence Team.',
        collapseHeader:
          'This is the minimum number of answers we need in each sector!',
        warningSpan: '*Warning!',
        warningText:
          'Fill in all the boxes or you won’t be able to move forward. If there is a sector that isn’t participating, then write a 0 in that box.',
        activationButtonText: 'Continue activation',
        activationButtonBoldText: 'Only one more step!',
      },
      termsAndConditions: {
        title: 'READ AND ACCEPT TERMS AND CONDITIONS',
        welcomeText1:
          'Welcome to the terms and conditions of use of the BRAVE UP! DATA function.',
        welcomeText2:
          'By accepting the following terms and conditions you are declaring that you agree with the following statements:',
        conditionText1:
          'Participation in this diagnosis consists in the implementation of an instrument that lasts 45 minutes at the most, estimating an average of 20-30 minutes. Duration can vary considering the age of the participants and their reading capacity.',
        conditionText2:
          'The community’s participation in this diagnosis is completely voluntary. Any member of the community is free to decline participation or suspend it whenever deemed convenient, without explanation and shall suffer no consequences from this decision.',
        conditionText3:
          'The information provided by the participants will be confidential and anonymous, that is, neither their names, I.D. numbers, nor other personal data will be published or shared. Moreover, the results of the data collection will be presented in an aggregated manner, in other words, the specific answers that each one gave cannot be known.',
        conditionText4:
          'Notwithstanding that BRAVE UP! DATA provides the necessary resources for the dissemination and implementation of the instrument, the school is responsible for coordinating and sharing the information with the community to ensure their participation.',
        conditionText5:
          'The construction of the instrument is based in a long investigation and validation process which gives the questions posed theoretical and methodological background. This is why the school cannot request modifications because it would affect its consistency and coherence.',
        conditionText6:
          'After the data collection BRAVE UP! DATA will analyze the information and produce a results report which will be available in this same platform no longer than three weeks after the closure of the instrument.',
        conditionText7:
          'The information collected will be delivered to the school with the purpose of improving school coexistence. In turn, it can be used for scientific purposes, such as publications or congresses, as well as diffusion in printed and digital media, with the objective of contributing with applied knowledge about physical and digital school coexistence and its variables. The name of the school or any data that enables its identification will never be published.',
        conditionText8:
          ' The information will be stored by BRAVE UP! in its computers during a 4 year period. The only people with access to this information are the professionals who have previously signed a confidentiality agreement about the use of information, in compliance with Law 19,628.',
        conditionText9:
          'Copyright ownership of all and any information related to the instrument and its analysis belongs to BRAVE UP! Its total or partial copy, reproduction, distribution or edition is forbidden without BRAVE UP!’s express authorization. Any unauthorized total or partial copy, reproduction, distribution or edition will be penalized according to Law Nº 17,736 and its modifications.',
        checkboxText:
          'I have read and accept BRAVE UP! DATA’s terms and conditions',
        backButton: 'Back',
        buttonConfirmText: 'Confirm',
        buttonActivationText: 'Activation',
        modalBackButton: 'Back to DATA',
        modalButtonDownloadText1: 'Download charts',
        modalButtonDownloadText2: 'and manual',
        modalTitle: 'Request successfully sent!',
        modalParagraph1: 'Survey will be activated in a maximum 72 hours.',
        modalParagraph2:
          'Remember to download the dissemination charts, share the orientation guide for the collection of data in class with the teachers and start preparing everything in your school.',
        alertMessage: 'Your request has been sent',
      },
      activeInstruments: {
        dividerTitle: 'ACTIVATE AND DEACTIVATE THE INSTRUMENTS',
        introText1:
          'In order to start collecting data, you must request the activation of the instrument you wish to implement in your school.',
        introText2:
          '* The School Coexistence Diagnosis is designed to be implemented in a 2 week period, during which time you must remember to deactivate the survey so that we can begin the data analysis. If during this period of time you haven’t reached the minimum number of answers necessary or should you forget to request its closure, the survey will automatically be extended for 1 more week.',
        item1Title: 'School Coexistence Diagnosis',
        item1Button1: 'Start activation',
        item1Button2Text1: 'Download resources',
        item1Button2Text2: 'support',
        item1Button3Text1: 'Request closure and delivery',
        item1Button3Text2: 'of results',
        modal1Title: 'You’re about to close this instrument!',
        modal1CancelButton: 'Cancel',
        modal1ConfirmButtonText1: 'Confirm closure and',
        model1ConfirmButtonText2: 'request results',
        modal2Title: 'Request successfully sent!',
        modal2ButtonText: 'Return to DATA',
        modal2Text:
          'We are preparing your report. In a few weeks we will notify you when it will be available for downloading.',
        modal1Text1:
          'This means that nobody else can answer it and BRAVE UP! DATA will begin to prepare the results report.',
        modal1Text2: 'Are you sure you want to continue?',
        item2Title: 'Sociogram',
        item2Button1: 'Shortly',
        messageSuccessSociogram: 'Successful activation',
        activatedSociogramMessage: 'Activated Sociogram',
        completedSociogramMessage: 'Sociogram completed',
        activationSociogramMessage: 'Start Activation',
      },
      confirmSurvey: {
        errorNoInstrumentText1: 'Dear',
        errorNoInstrumentText2: ', there is no instrument available yet.',
        title: 'School Coexistence Diagnosis',
        helloText: 'Hello!',
        introText:
          'Before getting started, we invite you to watch the following video:',
        question: 'Do you want to participate?',
        errorFormText: 'Chose at least one answer',
        radioText1: 'Yes, I want to participate.',
        radioText2: 'No, I don’t want to participate.',
        formButton: 'Next',
        messageSurveySentText1: 'Dear',
        messageSurveySentText2:
          ', your survey was already sent in another occasion, thank you for your time.',
      },
      pendingSurvey: {
        messagePending:
          'Dear user, You have a pending survey. To come back to the survey please click on continue.',
        continueButton: 'Continue',
      },
      startSurvey: {
        title: 'Well Beign Diagnosis',
        messageStart:
          'Before getting started, we invite you to watch the following video:',
        askMessage: 'Do you want to participate?',
        yesMessage: 'Yes, I want to participate.',
        noMessage: 'No, I don’t want to participate.',
        nextMessage: 'Next',
        messageRequired: 'Chose at least one answer',
      },
      desertSurvey: {
        backButtonText: 'Back to DATA',
        text1: 'Dear Sir/Madam',
        text2:
          ', the opinion of the entire community is fundamental in order to improve school coexistence. If you have second thoughts and want to answer again, we invite you to click on the diagnosis and participate!',
        text3: 'Have a good day!',
      },
      tracking: {
        title: 'FOLLOW UP AND CHECK THE RESULTS',
        introText:
          'In this section you can check how many members of your community have answered the instruments you activated. If you requested closure, a report is available here with the main results and a series of recommendations drawn by BRAVE UP!’s Education Team',
        item1Title: ' School Well Beign Diagnosis',
        item1Button1Text: 'Follow up',
        item1Button2Text1: 'Download',
        item1Button2Text2: 'The results',
        item2Title: 'Sociogram',
        item2Button1Text: 'Coming Soon',
        item2Button2Text: 'Dashboard',
      },
      advanceStatus: {
        message1: 'You can still make it! Improve dissemination',
        message2: 'We’re doing well! Keep on motivating participation',
        message3: 'Congratulations! Full staff',
        dividerTitle: 'PROGESS STATUS',
        introText1:
          'We will now inform you of the progress of the data collection process in your school. This will be updated as we receive answers from the community and based on this, we will make recommendations to increase or maintain the participation of the different sectors.',
        introText2:
          'If all the sectors reach or overcome 100% participation two weeks after the activation of the survey, you can request closing the process by clicking on the button under the chart. Otherwise we suggest it be kept open for another week and try to boost participation. Remember: it is paramount to reach the minimum number of answers!',
        tableHeadText1: 'Total number per sector',
        tableHeadText2: 'Minimum number of answers',
        tableHeadText3: 'Number of answers collected',
        tableHeadText4: 'Progress percentage',
        tableHeadText5: 'Recommendation',
        tableRowText1: 'Teachers',
        tableRowText2: 'Educational assistants',
        tableRowText3: 'Parents',
        tableRowText4: 'Students',
        tableRowText5: 'Total',
        requestButtonText1: 'Request closure and',
        requestButtonText2: 'delivery of the results',
        modal1Title: 'You’re about to close this instrument!',
        modal1CancelButton: 'Cancel',
        modal1ConfrimButtonText1: 'Confirm closure',
        modal1ConfrimButtonText2: 'and request results',
        modal2Title: 'Request successfully sent!',
        modal2BackButton: 'Back to DATA',
        modal2Paragraph:
          'We are preparing your report. In a few weeks we will notify you when it is ready for download.',
        modal1Paragraph1:
          'This means that nobody else can answer it and BRAVE UP! DATA will start preparing the results report.',
        modal1Paragraph2: 'Are you sure you want to continue?',
      },
      sociogram: {
        activeSociogramModal: {
          modalTitle: 'You are about to create a new sociogram!',
          modalBody: 'Are you sure you want to continue?',
          modalButton1: 'Cancel',
          modalButton2: 'Start Activation',
          errorMessageModal: 'Oops, try again!',
          messageSuccess: 'Successful Sociogram Activation',
        },
        finishSociogramModal: {
          buttonModalText: 'End sociogram',
          modalTitle: '¡You are about to finish the sociogram!',
          modalBody: 'Are you sure you want to continue?',
          modalButton1: 'Cancel',
          modalButton2: 'Confirm',
          errorMessageModal: 'Oops, try again!',
          messageSuccess: 'Successful sociogram completion',
        },
      },
      dashBoardSociogram: {
        title: 'Sociogram Dashboard',
        buttonText: 'MORE',
        courseTitle: 'Sociogram Results',
        tableTitle: 'Students',
        toolTitle: 'Tools',
        toolSubTitle: 'Groups of Work',
        graphTitle: 'Download Sociogram Charts',
        workingMessage:
          'Once the sociogram is finished, you can download the charts here!',
        group2Text: 'GROUPS OF 2',
        group3Text: 'GROUPS OF 3',
        group4Text: 'GROUPS OF 4',
        tableHeader1: 'Name',
        tableHeader2: 'Email',
        tableHeader3: 'Gender',
        tableHeader4: 'Popularity',
        tableHeader5: 'Conflictivity',
        level1: 'Very high',
        level2: 'High',
        level3: 'Medium',
        level4: 'Low',
        level6: 'None',
        level5: 'Very low',
      },
      answerSociogram: {
        title: 'SOCIOGRAM',
        sociogramDescription1:
          'We are the BRAVE UP team! We want to help improve school coexistence and relationships within your community. For that, we invite you to answer the following questions and tell us who your friends are, who you like to work with, and how you feel at your school.',
        sociogramDescription2:
          '  There are no good or wrong answers; we want to know about you and any problem between your classmates that we can help. Therefore, your participation is essential, as it will allow the guidance team to understand how they can improve relationships between all of you. Responding will take only 15 minutes.',
        sociogramDescription3:
          'Please get involved, and lets build a better school community together!',
        buttonText: 'START THE SOCIOGRAM',
        buttonText2: 'NEXT PAGE',
        noSociogramText: 'No sociogram available',
        warningMessage: 'Remember to check your answers before to continue',
        noQuestions: 'There are no questions availables',
        answeredSociogram: 'answered sociogram',
      },
    },
  },
};
